/** Curated, appropriately licensed photography (Unsplash / Pexels).
 * These are illustrative images — they do not depict Mount Moriah Relief
 * beneficiaries or completed projects. Replace entries here with approved
 * original photographs when available. */
export const IMAGES = {
  heroZimbabwe: {
    src: "https://images.unsplash.com/photo-1642086069849-2514084e9986?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHw0fHx6aW1iYWJ3ZSUyMGxhbmRzY2FwZXxlbnwwfHx8fDE3OTI3OTI4MDB8MA&ixlib=rb-4.1.0&q=85",
    alt: "Lush green Zimbabwean hillside covered in trees beneath an open sky",
  },
  victoriaFalls: {
    src: "https://images.pexels.com/photos/27878404/pexels-photo-27878404.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    alt: "Aerial view of Victoria Falls, Zimbabwe",
  },
  agriculture: {
    src: "https://images.pexels.com/photos/37345040/pexels-photo-37345040.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    alt: "Farmers tending crops together in a rural field",
  },
  harvest: {
    src: "https://images.pexels.com/photos/34705724/pexels-photo-34705724.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    alt: "A farmer holding freshly harvested crops in a green field",
  },
  classroom: {
    src: "https://images.pexels.com/photos/32293359/pexels-photo-32293359.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    alt: "Students participating in a classroom lesson, raising their hands",
  },
  students: {
    src: "https://images.pexels.com/photos/39523813/pexels-photo-39523813.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    alt: "Students attentively taking part in a classroom session",
  },
  northernIreland: {
    src: "https://images.pexels.com/photos/34759590/pexels-photo-34759590.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    alt: "Cliffs and ocean along the Northern Ireland coastline",
  },
  volunteers: {
    src: "https://images.pexels.com/photos/6647015/pexels-photo-6647015.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    alt: "Volunteers moving boxes of donated aid supplies",
  },
  volunteersAid: {
    src: "https://images.pexels.com/photos/6646918/pexels-photo-6646918.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    alt: "Volunteers preparing aid packages for distribution",
  },
};
